import React from 'react';
import PropTypes from 'prop-types';

/**
 * Composant LayoutBody - Corps principal du layout
 *
 * @component
 * @param {Object} props - Props du composant
 * @param {React.ReactNode} props.children - Contenu à afficher
 * @param {Object} props.state - État du layout (me, variables, etc.)
 * @param {Function} props.emitEvent - Fonction d'émission d'événements
 * @param {string} props.className - Classe CSS additionnelle
 * @returns {JSX.Element} Composant rendu
 */
const LayoutBody = ({
  children,
  state,
  emitEvent,
  className = '',
  ...props
}) => {
  return (
    <div className={className} {...props}>
      {React.cloneElement(children, {
        ...state,
        emitEvent,
      })}
    </div>
  );
};

// PropTypes
LayoutBody.propTypes = {
  children: PropTypes.node.isRequired,
  state: PropTypes.shape({
    me: PropTypes.any,
    variables: PropTypes.object,
  }).isRequired,
  emitEvent: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default LayoutBody;
